export default {
  GET_MONEY_REPORT: state => state.moneyReport,
}
